<div class="platform-user-notifications-wrapper">
  <markant-icon-button
    id="open-notification-popover-btn"
    data-cy="open-notification-popover-btn"
    class="customizable-icon"
    [icon]="'assets/images/login/alert_icon.svg'"
    [class.has-new-notifications]="$notificationCount()"
    [class.width--small]="$notificationsWidthSmall()"
    [class.width--big]="$notificationsWidthBig()"
    [attr.data-new-notifications]="$notificationCount()"
    [class.active]="showPopover"
    (click)="togglePopover()"
    (keydown.enter)="togglePopover()"
  >
  </markant-icon-button>

  <markant-popover
    id="notification-popover"
    data-cy="notification-popover"
    trigger="click"
    placement="bottom-start"
    for="open-notification-popover-btn"
    distance="30"
    [visible]="showPopover"
    (backdrop)="closePopover()"
  >
    <div
      class="notifications-wrapper"
      *ngIf="userNotifications$ | async as userNotifications"
    >
      <h4 class="markant-h4">
        {{ 'notifications.userNotifications.notifications' | transloco }}
      </h4>

      <div class="toggle-tiles">
        <markant-switch
          class="tile-switch"
          [checked]="unreadOnlyEnabled"
          [disabled]="false"
          (checkedChange)="toggleNotifications()"
        >
          {{ 'notifications.userNotifications.showUnreadOnly' | transloco }}
        </markant-switch>
      </div>

      @if (userNotifications.length && (reloadContents$ | async)) {
        <cdk-virtual-scroll-viewport
          autosize
          class="notification-tiles-wrapper"
          [style.height.px]="scrollHeight"
        >
          <div
            *cdkVirtualFor="let notification of userNotifications"
            class="notification-tile"
            [ngClass]="{ unread: !notification.recipients[0]?.read }"
          >
            <div
              class="tile-content flex-row-centered"
              data-markant-close
              (click)="navigateToNewsItem(notification)"
              (keydown.enter)="navigateToNewsItem(notification)"
            >
              <div class="tile-inner">
                <div class="tile-inner-top flex-row-centered">
                  @if (notification.author.length > overflowAuthorNameLength) {
                    <markant-tooltip
                      [label]="notification.author"
                      for="notification-{{ notification.id }}"
                      placement="top"
                      trigger="mouseenter focus"
                      colorScheme="dark"
                    >
                    </markant-tooltip>
                  }

                  <div
                    id="notification-{{ notification.id }}"
                    class="creator-name"
                    [class.long-text]="
                      notification.author.length > overflowAuthorNameLength
                    "
                  >
                    {{ 'notifications.userNotifications.from' | transloco }}:
                    {{ notification.author }}
                  </div>

                  <span>{{
                    notification.releaseAt | DateTime: 'dd/MM/YYYY'
                  }}</span>
                </div>

                <p class="platform-m-0">
                  {{ notification.userMessage.message }}
                </p>
              </div>
            </div>

            <markant-icon-button
              class="delete-notification-button"
              icon="m_trash"
              (click)="deleteNotification(notification)"
              (keydown.enter)="deleteNotification(notification)"
            >
            </markant-icon-button>
          </div>

          @if ((loadedAllResult$ | async) === false) {
            <div class="spinner-wrapper flex-centered">
              <markant-spinner
                type="circle"
                colorScheme="light"
              ></markant-spinner>
            </div>
          }
        </cdk-virtual-scroll-viewport>
      }

      @if (userNotifications.length) {
        <div class="notifications-wrapper-bottom">
          <markant-button
            colorScheme="primary"
            variant="clear"
            (click)="markAllUserNotificationsAsRead()"
            (keydown.enter)="markAllUserNotificationsAsRead()"
          >
            {{ 'notifications.userNotifications.markAllAsRead' | transloco }}
          </markant-button>
        </div>
      } @else {
        @if ((loadedFirstResult$ | async) === false) {
          <div class="spinner-wrapper flex-centered">
            {{ 'general.loading' | transloco }} <br />
            <markant-spinner></markant-spinner>
          </div>
        } @else {
          <h3>
            {{
              'notifications.userNotifications.missingNotifications' | transloco
            }}
          </h3>
        }
      }
    </div>
  </markant-popover>
</div>
